import React from 'react';
import { Spin } from 'antd';

const SessionLoading = () => (
  <div
    data-testid="auth-loading"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}
  >
    <Spin size="large" />
  </div>
);

export default SessionLoading;
